import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'menuColorClass',
    standalone: false
})

export class MenuColorClassPipe implements PipeTransform {
  transform(value: string | undefined): string | undefined {
    if (value && typeof value === 'string') {
      return 'color-' + value.toLocaleLowerCase();
    }

    return value;
  }
}
